import { sortBy } from 'lodash';
import type { IElementPropertyOption } from '../../../models/element-property.model';
import { genericProductsLookup } from '../../../generic-products';
import { pick } from '../../../helpers/object.helpers';

export const ENERGY_PROPERTY_PRODUCTS_NAME = 'products';

export enum EnergyProductId {
  /**
   * Electricity (Swedish mix)
   */
  Electricity = 'boverket_sv-SE_6000000008',

  /**
   * Diesel with a part of bio product
   */
  DieselReductionObligation = 'boverket_sv-SE_6000000010',

  /**
   * Standard diesel
   */
  Diesel = 'boverket_sv-SE_6000000011',

  /**
   * Petrol with a part of bio product
   */
  PetrolReductionObligation = 'boverket_sv-SE_6000000012',

  /**
   * Standard petrol
   */
  Petrol = 'boverket_sv-SE_6000000013',

  /**
   * Heating product centrally (fjärrvärme)
   */
  DistrictHeating = 'boverket_sv-SE_6000000014',

  /**
   *
   * HVO100 (Hydrotreated Vegetable Oil) is a 100% renewable and fossil-free diesel fuel produced from residual products such as vegetable oils and animal fats
   */
  HVO100 = 'boverket_sv-SE_6000000017',
  Gasol = 'boverket_sv-SE_6100000000',
  WoodPellets = 'boverket_sv-SE_6100000001',

  /**
   * E85 (Ethanol 85%, petrol 15%)
   */
  E85 = 'boverket_sv-SE_6100000002',

  /**
   * Biogas (produced from organic waste or other organic materials)
   */
  Biogas = 'boverket_sv-SE_6100000003',

  /**
   * Fuel oil made to heat homes (less environmetal demands than fuel oil 2-5)
   */
  FuelOil1 = 'boverket_sv-SE_6100000004',

  /**
   * Fuel oil 2-5, mostly used for heavy machinery like ships and stationary engines
   */
  FuelOil2 = 'boverket_sv-SE_6100000005',

  /**
   * Biodiesel made from soy or rapeseed
   */
  FAME100 = 'boverket_sv-SE_6100000006',

  /**
   * Ethanol fuel for diesel engines
   */
  ED95 = 'boverket_sv-SE_6100000007',

  /**
   * District cooling (fjärrkyla). Like district heating, but for cooling.
   */
  DistrictCooling = 'nodon_district_cooling',
}

/** Default `products` select value: generic product id (not display name). */
export const DEFAULT_ENERGY_PRODUCT_ID = EnergyProductId.Electricity;

/** Used in tests and callers that need the district-heating row id. */
export const DISTRICT_HEATING_PRODUCT_ID = EnergyProductId.DistrictHeating;

export const energyProductLoopup = pick(
  genericProductsLookup,
  ...Object.values(EnergyProductId),
);

export const energyProducts = Object.values(energyProductLoopup);

/**
 * Energy `products` select: {@link IElementPropertyOption.value} is the generic
 * product id; {@link IElementPropertyOption.label} is the display name.
 */
export const energyProductSelectOptions: IElementPropertyOption[] = sortBy(
  energyProducts,
  ({ name }) => name,
).map(({ id, name }) => ({ label: name, value: id }));
